import React, { Fragment, useState } from "react";
import DashHeader from "../components/Includes/DashHeader";
import UserLeftSide from "../components/Includes/UserLeftSide";
import "../assets/frontend/css/student-shell.css";

const UserLayout = (props) => {
  const [isActive, setActive] = useState(false);

  const handleToggleMenu = () => {
    setActive(!isActive);
  };

  return (
    <Fragment>
      <div className={`App student-app-shell ${isActive ? "menu-open" : ""}`}>
        <UserLeftSide />
        <div className="student-app-main">
          <DashHeader />
          <div className="nav-togg" onClick={handleToggleMenu}>
            <span></span>
          </div>
          <div className="student-app-content">{props.children}</div>
        </div>
      </div>
    </Fragment>
  );
};

export default UserLayout;
